/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Scope_Item_1Inputs */

const es_privacy_policy_scope_item_1 = /** @type {(inputs: Privacy_Policy_Scope_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los datos personales recopilados a traves de nuestro sitio web (nexata.app)`)
};

const en_privacy_policy_scope_item_1 = /** @type {(inputs: Privacy_Policy_Scope_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All personal data collected through our website (nexata.app)`)
};

/**
* | output |
* | --- |
* | "All personal data collected through our website (nexata.app)" |
*
* @param {Privacy_Policy_Scope_Item_1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_scope_item_1 = /** @type {((inputs?: Privacy_Policy_Scope_Item_1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Scope_Item_1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_scope_item_1(inputs)
	return en_privacy_policy_scope_item_1(inputs)
});
export { privacy_policy_scope_item_1 as "privacy_policy.scope.item_1" }